/* eslint-disable max-len */
import React, { useEffect } from 'react';
import '@babel/polyfill';
import { ConfigProvider } from 'antd-mobile';
import { I18nextProvider } from 'react-i18next';

import enUS from 'antd-mobile/es/locales/en-US';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { GoogleOAuthProvider } from '@react-oauth/google';
import '@chatui/core/dist/index.css';
import { showPageLoading, hidePageLoading } from '@/utils/business.js';
import GlobalStoreProvider from './storeGlobal';
import '../styles/globals.css';
import '../styles/theme.css';
import { getUrlParams } from '@/utils/env';
import { initAnalytics } from '@/utils/analytics';

function MyApp({ Component, pageProps }) {
  const router = useRouter();

  useEffect(() => {
    const handleRouteStart = () => {
      showPageLoading();
    };

    const handleRouteError = (err) => {
      hidePageLoading();
    };

    const handleRouteChange = (url) => {
      hidePageLoading();
    };

    router.events.on('routeChangeStart', handleRouteStart);
    router.events.on('routeChangeError', handleRouteError);
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeStart', handleRouteStart);
      router.events.off('routeChangeError', handleRouteError);
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);
  useEffect(() => {
    // 初始化埋点SDK
    initAnalytics();

    // 生产环境 F12不展示报错
    if (process.env.NODE_ENV === 'production' && +getUrlParams('debug') !== 2) {
      disableConsole();
    }
  }, []);
  const disableConsole = () => {
    const noop = () => {};
    console.log = noop;
    console.warn = noop;
    console.error = noop;
    console.info = noop;
    console.debug = noop;
    console.table = noop;
    console.dir = noop;
    console.dirxml = noop;
    console.trace = noop;
    console.group = noop;
    console.groupCollapsed = noop;
    console.groupEnd = noop;
    console.time = noop;
    console.timeEnd = noop;
    console.timeLog = noop;
    console.timeStamp = noop;
    console.profile = noop;
    console.profileEnd = noop;
    console.count = noop;
    console.clear = noop;
    console.assert = noop;
  };

  return (
    <>
      <Head>
        <title>coolearn</title>
        <meta name="description" content="xxx" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="robots" content="index,follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0" />
        <meta name="keywords" content="" />
        <link rel="icon" />
        <noscript>
          <img
            height="1"
            width="1"
            style={{ display: 'none' }}
            src="https://www.facebook.com/tr?id=1871700513551023&ev=PageView&noscript=1"
          />
        </noscript>
      </Head>
      <ConfigProvider locale={enUS}>
        <GoogleOAuthProvider clientId={process.env.GOOGLE_CLIENT_ID}>
          <GlobalStoreProvider>
            <Component {...pageProps} />
          </GlobalStoreProvider>
        </GoogleOAuthProvider>
      </ConfigProvider>
    </>
  );
}

export default MyApp;
